import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function ProductionDashboard() {

  const [inventory, setInventory] = useState([]);
  const [report, setReport] = useState(null);

  const sellingPrice = 35;

  const recipe = {
    Pistha: 5,
    Badham: 6,
    Wallnut: 0.25,
    Cashews: 2,
    Drygrapes: 4,
    Ajwadates: 7,
    Pumpkinseed: 4
  };

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = () => {

    axios
      .get("http://tntyping.com/Adminconsole/api/nutsinventoryproductslists")
      .then((response) => {

        const result = response.data.result;
        const errorcode = response.data.errorCode;
        const message = response.data.Message;

        if (errorcode === 2) {
          Swal.fire({
            icon: "error",
            text: message
          });
        }

        if (errorcode === 0) {

          setInventory(result);

          calculateProduction(result);
        }

      });

  };


  const calculateProduction = (items) => {

    let pouchCounts = [];
    let pouchCost = 0;
    let breakdown = [];

    items.forEach((item) => {

      const name = item.productname.trim();

      if (recipe[name]) {

        const qtyKg = parseFloat(item.qty);
        const unitPrice = parseFloat(item.unitprice);

        const gramsAvailable = qtyKg * 1000;
        const gramsNeeded = recipe[name];

        const possiblePouches = gramsAvailable / gramsNeeded;

        pouchCounts.push(possiblePouches);

        const costPerGram = unitPrice / 1000;
        const ingredientCost = costPerGram * gramsNeeded;

        pouchCost += ingredientCost;

        breakdown.push({
          name,
          gramsAvailable,
          gramsNeeded,
          ingredientCost
        });

      }

    });

    const maxPouches = Math.floor(Math.min(...pouchCounts));
    const profitPerPouch = sellingPrice - pouchCost;
    const totalProfit = profitPerPouch * maxPouches;

    setReport({
      pouchCost,
      maxPouches,
      profitPerPouch,
      totalProfit,
      breakdown
    });

  };


  return (

    <div className="p-6 space-y-6">

      <h1 className="text-2xl font-bold text-gray-800">
        Nuts Production Dashboard
      </h1>


      {/* SUMMARY */}

      {report && (

        <div className="grid md:grid-cols-4 gap-4">

          <div className="bg-white shadow rounded-xl p-4">
            <p className="text-gray-500 text-sm">Cost per pouch</p>
            <p className="text-xl font-bold">
              ₹{report.pouchCost.toFixed(2)}
            </p>
          </div>

          <div className="bg-white shadow rounded-xl p-4">
            <p className="text-gray-500 text-sm">Selling Price</p>
            <p className="text-xl font-bold">
              ₹{sellingPrice}
            </p>
          </div>

          <div className="bg-white shadow rounded-xl p-4">
            <p className="text-gray-500 text-sm">Profit per pouch</p>
            <p className="text-xl font-bold text-green-600">
              ₹{report.profitPerPouch.toFixed(2)}
            </p>
          </div>

          <div className="bg-white shadow rounded-xl p-4">
            <p className="text-gray-500 text-sm">Max Pouches</p>
            <p className="text-xl font-bold text-blue-600">
              {report.maxPouches}
            </p>
          </div>

        </div>

      )}



      {/* INGREDIENT TABLE */}

      {report && (

        <div className="bg-white shadow rounded-xl overflow-hidden">

          <table className="w-full text-sm">

            <thead className="bg-gray-100">

              <tr>
                <th className="p-3 text-left">Ingredient</th>
                <th className="p-3 text-left">Available (g)</th>
                <th className="p-3 text-left">Used/Pouch (g)</th>
                <th className="p-3 text-left">Cost/Pouch</th>
              </tr>

            </thead>

            <tbody>

              {report.breakdown.map((item, index) => (

                <tr key={index} className="border-t">

                  <td className="p-3">{item.name}</td>
                  <td className="p-3">{item.gramsAvailable}</td>
                  <td className="p-3">{item.gramsNeeded}</td>
                  <td className="p-3">
                    ₹{item.ingredientCost.toFixed(2)}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      )}



      {/* TOTAL PROFIT */}

      {report && (

        <div className="bg-green-50 border border-green-200 rounded-xl p-6">

          <p className="text-sm text-gray-500">
            Total Profit (If all pouches sold)
          </p>

          <p className="text-3xl font-bold text-green-700">
            ₹{report.totalProfit.toFixed(2)}
          </p>

        </div>

      )}

    </div>

  );

}